// Styles
import styled from 'styled-components/macro'

// Core
import React from 'react'
import {useDispatch} from 'react-redux'

// Components, services, constants
import {openModal} from 'actions/modalActions'
import Address from 'components/Address'
import Button from 'components/Button'
import Image from 'components/Image'
import MetaDataList from 'components/MetaDataList'
import {COMPS_MODAL} from 'constants/modalsConstants'
import type {SubjectDataType} from 'services/addressServices'
import {getAddressImageUrl} from 'services/addressServices'

// 3rd party
import classnames from 'classnames'

import type {PropertyType} from 'types/propertyTypes'

export type PropertyOverviewHeroProps = {
  className?: string
  subjectData: SubjectDataType
} & Pick<PropertyType, 'pid'>

const PropertyOverviewHero = ({className, subjectData, pid}: PropertyOverviewHeroProps) => {
  const dispatch = useDispatch()
  const {address, metaData} = subjectData

  return (
    <PropertyOverviewHero.Styled className={classnames('property-overview-splash', className)}>
      <Image src={getAddressImageUrl(address)} width='100%' height='100%'>
        <div className='subject-data-display'>
          <div className='content-wrap'>
            <div className='details-wrap'>
              <h2 className='address'>
                <Address address={address} sqaPrefix='header' />
              </h2>
              <MetaDataList metaData={metaData} />
            </div>
            {pid && (
              <div className='similar-properties'>
                <Button
                  title='View Similar Properties'
                  onClick={() => {
                    dispatch(
                      openModal({
                        modalType: COMPS_MODAL,
                        pid,
                        mixpanelEventData: {
                          initiatedFrom: 'Property Overview Hero'
                        }
                      })
                    )
                  }}
                  variant='secondary'
                />
              </div>
            )}
          </div>
        </div>
      </Image>
    </PropertyOverviewHero.Styled>
  )
}

PropertyOverviewHero.Styled = styled.div`
  width: 100vw;
  height: 240px;
  .image-as-background {
    display: flex;
    align-items: flex-end;

    .subject-data-display {
      height: 100%;
      width: 100%;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.64) 99.23%);
      display: flex;
      align-items: flex-end;

      .content-wrap {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 0 40px 24px;
        .details-wrap {
          margin-bottom: 8px;
          .address,
          .meta-data {
            color: ${({theme}) => theme.colors.grayscale.white};
          }
          h2.address {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .image-cover.fallback {
    background-size: 128px;
    background-repeat: no-repeat;
    background-color: ${({theme}) => theme.colors.stone.light};
    .subject-data-display {
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.32) 99.23%);
    }
  }
`

export default PropertyOverviewHero
